
import TableList from "@components/templates/tablelist";
import { HttpAbnormalOrderList, HttpCancelAbnormalOrder,HttpBatchRecoverAbnormalOrder, HttpRetryAbnormalOrder, HttpRecoverAbnormalOrder } from "@/service/allotment";
import { mapGetters } from "vuex";
import mixin from "./mixin";
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_errorType: null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpAbnormalOrderList,
        goRouteBillDetial(params={}) {
            let name, { type, id, orderModule } = params;
            if ([300, 310, 320, 330].indexOf(Number(type)) > -1) name = "allotUpdateBill";//调拨计划单
            if (orderModule == 420) name = "inboundBillclientDetail";//入库计划单
            if (orderModule == 430) name = "inboundOrderDetail";//入库单
            if (orderModule == 500) name = "doublieworkorUpdate";//入库单
            if (!name) return;
            let url = this.$router.resolve({
                name,
                params: { type: "query" },
                query: { id },
            });
            window.open(url.href, '_blank');
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "query":
                    this.goRouteBillDetial(params);
                    break;
                case "retry":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "重处理",
                        ajaxRequest: HttpRetryAbnormalOrder
                    }
                    break;
                case "recover":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "恢复正常",
                        ajaxRequest: HttpRecoverAbnormalOrder
                    }
                    break;
                    case "batchRecover":
                        this.operate = {
                            show: true,
                            alert: "primary",
                            params: { ids: params },
                            title: "恢复正常",
                            ajaxRequest: HttpBatchRecoverAbnormalOrder
                        }
                        break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "取消单据",
                        width: 460,
                        desc: "取消后订单不可恢复，是否确认取消？",
                        params: { id: params },
                        ajaxRequest: HttpCancelAbnormalOrder,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "cancelReason",
                                span: 24,
                                label: "取消原因"
                            }
                        ]
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, orderType, orderId, status, orderModule } = row,
                show = status == 0;
            return [{
                label: '查看详情',
                show: [300, 310, 320, 330].indexOf(Number(orderType)) > -1 || orderModule == 420 || orderModule == 430,
                params: {
                    id: orderId,
                    type: orderType,
                    orderModule
                },
                operate: 'query'
            }, {
                label: '重处理',
                show: show,
                params: id,
                operate: 'retry'
            }, {
                label: '恢复正常',
                show: show,
                params: id,
                operate: 'recover'
            }, {
                label: '取消单据',
                show: show,
                params: id,
                operate: 'cancel'
            }]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getWarehouseAllList','getUserManageWarehouseList', 'getOrgList']),
        TabsData() {
            //异常类型
            //         PUSH_ERROR(0,"推送异常"),
            // RETURN_ERROR(1,"回传异常"),
            // CANCEL_ERROR(2,"取消异常"),
            // ESTIMATE_ERROR(3,"测算异常"),
            // BUY_LABEL_ERROR(4,"label购买异常"),
            // CHECK_ERROR(5,"审核异常");
            return [
                {
                    label: "所有",
                    key: 'EQ_errorType',
                    value: null
                }, {
                    label: "推送异常",
                    key: 'EQ_errorType',
                    value: 0
                }, {
                    label: "回传异常",
                    key: 'EQ_errorType',
                    value: 1
                }, {
                    label: "取消异常",
                    key: 'EQ_errorType',
                    value: 2,
                },
                //  {
                //     label: "测算异常",
                //     key: 'EQ_errorType',
                //     value: 3,
                // }, {
                //     label: "label购买异常",
                //     key: 'EQ_errorType',
                //     value: 4,
                // }, {
                //     label: "审核异常",
                //     key: 'EQ_errorType',
                //     value: 5,
                // }
            ]
        },
        ToolsData() {
            return [
                {
                    label: "重处理",
                    operate: "retry",
                    theme: "primary",
                    batch: true,
                },
                {
                    label: "恢复正常",
                    operate: "batchRecover",
                    theme: "info",
                    batch: true,
                    
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "单号",
                    tag: 'vInput',
                    key: 'EQ_orderNo',
                    show: true,
                },
                {
                    label: "异常类型",
                    tag: 'vSelect',
                    key: 'EQ_errorType',
                    options: this.getAbnormalType,
                    show: true,
                },
                {
                    label: "异常模块",
                    tag: 'vSelect',
                    key: 'EQ_orderModule',
                    options: this.getBillModule,
                    show: true,

                },
                {
                    label: "组织",
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    options: this.getOrgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "仓库",
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "单据状态",
                    tag: 'vSelect',
                    key: 'EQ_status',
                    default:0,
                    options: this.getBillStatus,
                },
                {
                    label: "来源单号",
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    style: "width:362px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yy-mm-dd 00:00:00~yy-mm-dd 23:59:59',
                        confirm: false,
                    },
                }
            ]
        },
        columns() {
            return [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            }, {
                title: '操作',
                align: 'center',
                maxWidth: 90,
                render: this.getOperateNodes
            }, {
                title: '组织',
                key: 'organizationId',
                render: (h, { row }) => this.findRenderLabel(this.getOrgList, row.organizationId)
            },
            {
                title: '单号',
                key: 'orderNo',
                render: (h, { row }) => {
                    return <a class="color-link" onClick={this.handleOperates.bind(this, { id: row.orderId, type: row.orderType, orderModule: row.orderModule }, 'query')}>{row.orderNo}</a>
                }
            },
            {
                title: '来源单号',
                key: 'sourceNo',
            },
            {
                title: '单据状态',
                key: 'status',
                render: (h, { row }) => {
                    const status = row.status;
                    const { theme = 'default', label } = this.getBillStatus.find(function (item) {
                        return item.value == status
                    }) || {};
                    return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{label}</vButton>
                }
            },
            {
                title: '单据类型',
                key: 'orderType',
                render: (h, { row }) => this.findRenderLabel(this.getBillType, row.orderType)
            },
            {
                title: '仓库',
                key: 'orgWarehouseCode',
                // render: (h, { row }) => this.findRenderLabel(this.getWarehouseAllList, row.orgWarehouseId)
            },
            {
                title: '异常类型',
                key: 'errorType',
                render: (h, { row }) => this.findRenderLabel(this.getAbnormalType, row.errorType)
            },
            {
                title: '异常模块',
                key: 'orderModule',
                render: (h, { row }) => this.findRenderLabel(this.getBillModule, row.orderModule)
            },
            {
                title: '操作类型',
                key: 'operateType',
                render: (h, { row }) => this.findRenderLabel(this.getOperateType, row.operateType)
            },
            {
                title: '异常原因',
                key: 'errorMessage',
            },
            {
                title: '创建日期',
                key: 'createdAt',
                sortable: true
            },
            ];
        },

    },

};
